var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBolt = function SvgIconBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-bolt_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-bolt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M9.104 14.813 12.917 10H9.813l.541-4.604L6.75 11h3.042l-.688 3.813ZM8 12.5H5.375a.687.687 0 0 1-.646-.385.716.716 0 0 1 .021-.76l5.646-8.813a.8.8 0 0 1 .479-.386c.208-.062.417-.059.625.01a.9.9 0 0 1 .49.386.909.909 0 0 1 .135.615L11.5 8.5h2.958c.32 0 .546.139.677.417.132.277.101.541-.093.791l-6.167 7.813a.998.998 0 0 1-.51.333.807.807 0 0 1-.594-.062 1.025 1.025 0 0 1-.448-.427.845.845 0 0 1-.094-.594L8 12.5Z"
  }))));
};
export default SvgIconBolt;